import {createApp} from 'vue'
import CalculatorInfoBox from './CalculatorInfoBox'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps.js'


const el = '.nyk-component--info-box'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CalculatorInfoBoxDOM) => {
            const props = handleComponentProps(CalculatorInfoBox, InfoBoxDOM)
            const component = createApp(CalculatorInfoBox, props).use(Store)
            component.mount(CalculatorInfoBoxDOM)
        })
    }
}